import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';

@Component({
    selector: 'app-access-bb-invitation',
    templateUrl: './access-bb-invitation.component.html',
    styleUrls: ['./access-bb-invitation.component.scss'],
    standalone: false
})
export class AccessBbInvitationComponent {

  guid:string=''
  constructor(private route:ActivatedRoute,private _bbinvitationservice:BbInvitationService,private router:Router) { }
  
  ngOnInit(): void 
  {
      this.route.params.subscribe(params=>{
        this.guid=params['guid'];
        this._bbinvitationservice.accessBBInviteLink(this.guid).subscribe({
          next:(res)=>
            {
              this.router.navigateByUrl('/'+res.redirectTo)
            }
        })
      })
   }
}
